import React from "react"
import { Badge } from "reactstrap"

const ProductPrice = ({ price }) => {
  return (
    <>
      {price ? (
        `NT$ ${price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`
      ) : (
        <Badge
          color="info"
          style={{
            top: "-1.25px",
            position: "relative",
            fontSize: "12px"
          }}
        >
          <strong>待業務報價</strong>
        </Badge>
      )}
    </>
  )
}

export default ProductPrice
